module.exports = __webpack_public_path__ + "d410cac9573e8eed8ab6f3f57911473e.svg";